import { urlForImage } from "@/js/sanity/image";
import VideoPlayer from "@/components/video/VideoPlayer.vue";
export default {
  name: "PostSection2",
  components: {
    VideoPlayer: VideoPlayer
  },
  methods: {
    urlForImage: urlForImage
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};